/* eslint-disable */

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { FaCaretDown } from 'react-icons/fa';
import { appAssets } from 'constants/assets';
import './Breadcrumb.scss';
import { transformGridData } from 'helpers/dataGridTransformation';

const CloseIcon = appAssets.icons.CLOSE;

type BreadcrumbItem = { value: string; label: string };

interface BreadCrumbProps {
  context: any;
  bundledData?: any;
  onChangeCategory?: (category: any) => void;
  onRequestClose: () => void;
  // Optional generic dropdown mode
  items?: BreadcrumbItem[];
  selectedValue?: string;
  onChangeItem?: (value: string) => void;
  labelLeft?: string;
  hideClose?: boolean;
  placeholderLabel?: string;
  isPadding?: boolean;
  hideLabel?: boolean;
}

function BreadCrumb({
  context,
  bundledData,
  onChangeCategory,
  onRequestClose,
  items,
  selectedValue,
  onChangeItem,
  labelLeft,
  hideClose,
  isPadding = true,
  placeholderLabel = 'Filter by Sentiment',
  hideLabel = false,
}: BreadCrumbProps) {
  const { l1categoryname, l2categoryname } = context;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const breadcrumbRef = useRef<HTMLDivElement>(null);

  // Transform category list data to use ColName keys
  const transformedCategoryList = useMemo(() => {
    if (!bundledData?.data?.data || !bundledData?.data?.columns) return null;
    return transformGridData(bundledData.data.data, bundledData.data.columns);
  }, [bundledData?.data?.data, bundledData?.data?.columns]);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (breadcrumbRef.current && !breadcrumbRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    },
    [breadcrumbRef]
  );

  // Close dropdowns when clicking outside
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const isCustomMode = Array.isArray(items) && items.length > 0 && !!onChangeItem;
  const leftLabel = isCustomMode
    ? labelLeft ?? l1categoryname ?? 'Session Transcript'
    : l1categoryname;
  const selectedLabel = isCustomMode
    ? selectedValue
      ? items?.find((i) => i.value === selectedValue)?.label ?? selectedValue
      : placeholderLabel
    : l2categoryname;

  const containerClass = `breadcrumb_container${isPadding ? ' breadcrumb_container-padding' : ''}`;

  return (
    <div className="breadcrumb_top-section-container">
      <div className={containerClass} ref={breadcrumbRef}>
        {isCustomMode ? (
          <div className="breadcrumb_row">
            {!hideLabel && <span className="breadcrumb_item">{leftLabel}</span>}
            <div className="breadcrumb_item-wrapper">
              <span
                className="breadcrumb_item"
                onClick={() => {
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                {selectedLabel} <FaCaretDown />
              </span>
              {dropdownOpen && (
                <div className="breadcrumb_dropdown">
                  {items?.map((item: BreadcrumbItem, index: number) => (
                    <div
                      key={item.value ?? index}
                      className="breadcrumb_dropdown-item"
                      onClick={() => {
                        setDropdownOpen(false);
                        onChangeItem && onChangeItem(item.value);
                      }}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            {!hideLabel && (
              <>
                <div className="breadcrumb_item-wrapper">
                  <span className="breadcrumb_item">{l1categoryname}</span>
                </div>
                <span className="breadcrumb_spacer">/</span>
              </>
            )}
            <div className="breadcrumb_item-wrapper">
              <span
                className="breadcrumb_item"
                onClick={() => {
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                {l2categoryname} <FaCaretDown />
              </span>
              {dropdownOpen && transformedCategoryList && (
                <div className="breadcrumb_dropdown">
                  {transformedCategoryList.map((category: any, index: number) => (
                    <div
                      key={index}
                      className="breadcrumb_dropdown-item"
                      onClick={() => {
                        setDropdownOpen(false);
                        onChangeCategory?.(category);
                      }}
                    >
                      {category.l2categoryname}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
      {!hideClose && (
        <span className="tsc_close-button" onClick={() => onRequestClose()}>
          <IoMdCloseCircleOutline size={35} />
        </span>
      )}
    </div>
  );
}

export default BreadCrumb;
